"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimRewardTxb = claimRewardTxb;
exports.collectAndSwapRewardsSingleLoop = collectAndSwapRewardsSingleLoop;
exports.collectAndSwapRewardsLyf = collectAndSwapRewardsLyf;
const transactions_1 = require("@mysten/sui/transactions");
const index_js_1 = require("../index.js");
async function claimRewardTxb(address) {
    const txb = new transactions_1.Transaction();
    await (0, index_js_1.getMultiReceipts)(address);
    const alphaReceipt = await (0, index_js_1.getReceipts)("ALPHA", address, false);
    let alpha_receipt;
    if (alphaReceipt.length == 0) {
        [alpha_receipt] = txb.moveCall({
            target: `0x1::option::none`,
            typeArguments: [(0, index_js_1.getConf)().ALPHA_POOL_RECEIPT],
            arguments: [],
        });
    }
    else {
        [alpha_receipt] = txb.moveCall({
            target: `0x1::option::some`,
            typeArguments: [alphaReceipt[0].content.type],
            arguments: [txb.object(alphaReceipt[0].objectId)],
        });
    }
    const keys = Object.keys(index_js_1.poolInfo);
    for (const poolName of keys) {
        if (index_js_1.poolInfo[poolName].poolId == "") {
            continue;
        }
        const receipts = await (0, index_js_1.getReceipts)(poolName, address, false);
        if (poolName !== "ALPHA") {
            if (index_js_1.poolInfo[poolName].packageNumber === 9) {
                if (poolName === "NAVI-SUIBTC") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_pool_v2::get_user_rewards_all`,
                            typeArguments: [
                                index_js_1.coinsList[index_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_NAVI_V2_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
            }
            else if (index_js_1.poolInfo[poolName].packageNumber == 8) {
                if (poolName === "BLUEFIN-SUIBTC-USDC" ||
                    poolName === "BLUEFIN-LBTC-SUIBTC") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_type_1_pool::get_user_rewards_all`,
                            typeArguments: [
                                index_js_1.coinsList[index_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                                index_js_1.coinsList[index_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                            ],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
            }
            else if (index_js_1.poolInfo[poolName].packageNumber == 5) {
                if (poolName == "NAVI-LOOP-USDT-USDC") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_usdt_usdc_pool::get_user_rewards_all`,
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_5_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (poolName == "ALPHALEND-LOOP-SUI-STSUI") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_sui_stsui_pool::get_user_rewards_all`,
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_5_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
            }
            else if (index_js_1.poolInfo[poolName].packageNumber == 4 ||
                index_js_1.poolInfo[poolName].packageNumber == 6) {
                if (index_js_1.poolInfo[poolName].parentProtocolName == "BLUEFIN") {
                    const coinAName = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
                    const coinA = index_js_1.coinsList[coinAName];
                    const coinBName = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
                    const coinB = index_js_1.coinsList[coinBName];
                    if (poolName == "BLUEFIN-SUI-USDC" ||
                        poolName === "BLUEFIN-SUI-BUCK" ||
                        poolName === "BLUEFIN-SUI-AUSD") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_sui_first_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_4_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName == "BLUEFIN-USDT-USDC" ||
                        poolName === "BLUEFIN-AUSD-USDC" ||
                        poolName === "BLUEFIN-WBTC-USDC" ||
                        poolName === "BLUEFIN-SEND-USDC" ||
                        poolName === "BLUEFIN-SUIUSDT-USDC" ||
                        poolName === "BLUEFIN-WAL-USDC") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_type_1_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_4_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName === "BLUEFIN-ALPHA-USDC" ||
                        poolName === "BLUEFIN-NAVX-VSUI" ||
                        poolName === "BLUEFIN-BLUE-USDC") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_type_2_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_4_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName === "BLUEFIN-BLUE-SUI" ||
                        poolName === "BLUEFIN-WBTC-SUI" ||
                        poolName === "BLUEFIN-DEEP-SUI") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_sui_second_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_4_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName === "BLUEFIN-STSUI-SUI") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_stsui_sui_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_4_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName === "BLUEFIN-STSUI-USDC" ||
                        poolName === "BLUEFIN-STSUI-WSOL" ||
                        poolName === "BLUEFIN-STSUI-ETH" ||
                        poolName === "BLUEFIN-STSUI-BUCK" ||
                        poolName === "BLUEFIN-STSUI-MUSD") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_stsui_first_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_STSUI_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName === "BLUEFIN-ALPHA-STSUI" ||
                        poolName === "BLUEFIN-WAL-STSUI") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bluefin_stsui_second_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().ALPHA_STSUI_VERSION),
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                }
            }
            else if (index_js_1.poolInfo[poolName].packageNumber == 3) {
                if (index_js_1.poolInfo[poolName].parentProtocolName == "NAVI") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_pool_v2::get_user_rewards_all`,
                            typeArguments: [
                                index_js_1.coinsList[index_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_3_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (poolName == "BUCKET-BUCK") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_bucket_pool_v1::get_user_rewards_all`,
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_3_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
            }
            else if (index_js_1.poolInfo[poolName].packageNumber == 2) {
                if (poolName == "CETUS-SUI") {
                    const coinAName = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
                    const coinA = index_js_1.coinsList[coinAName];
                    const coinBName = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
                    const coinB = index_js_1.coinsList[coinBName];
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_cetus_sui_pool::get_user_rewards_all`,
                            typeArguments: [coinA.type, coinB.type],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_2_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (poolName == "NAVI-LOOP-SUI-VSUI") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_sui_vsui_pool::get_user_rewards_all`,
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_2_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (poolName == "NAVI-LOOP-USDC-USDT") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_native_usdc_usdt_pool::get_user_rewards_all`,
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_2_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (poolName == "NAVI-LOOP-HASUI-SUI") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_hasui_sui_pool::get_user_rewards_all`,
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_2_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
            }
            else {
                if (index_js_1.poolInfo[poolName].parentProtocolName == "CETUS") {
                    const coinAName = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
                    const coinA = index_js_1.coinsList[coinAName];
                    const coinBName = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
                    const coinB = index_js_1.coinsList[coinBName];
                    if (coinBName == "SUI") {
                        // txb.moveCall({
                        //   target: `${getConf().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_sui_pool::update_pool`,
                        //   typeArguments: [coinA.type, coinB.type],
                        //   arguments: [
                        //     txb.object(getConf().VERSION),
                        //     txb.object(poolInfo[poolName].poolId),
                        //     txb.object(poolInfo[poolName].investorId),
                        //     txb.object(getConf().ALPHA_DISTRIBUTOR),
                        //     txb.object(getConf().CETUS_GLOBAL_CONFIG_ID),
                        //     txb.object(getConf().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        //     txb.object(cetusPoolMap["CETUS-SUI"]),
                        //     txb.object(cetusPoolMap[poolName]),
                        //     txb.object(getConf().CLOCK_PACKAGE_ID),
                        //   ],
                        // });
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_cetus_sui_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else if (poolName == "WUSDC-WBTC" ||
                        poolName == "USDC-USDT" ||
                        poolName == "USDC-WUSDC" ||
                        poolName == "USDC-ETH") {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_cetus_pool_base_a::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                    }
                    else {
                        receipts.forEach((receipt) => {
                            alpha_receipt = txb.moveCall({
                                target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_cetus_pool::get_user_rewards_all`,
                                typeArguments: [coinA.type, coinB.type],
                                arguments: [
                                    txb.object((0, index_js_1.getConf)().VERSION),
                                    txb.object(receipt.objectId),
                                    alpha_receipt,
                                    txb.object(index_js_1.poolInfo[poolName].poolId),
                                    txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                                ],
                            });
                        });
                        // txb.moveCall({
                        //   target: `${getConf().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool::update_pool`,
                        //   typeArguments: [coinA.type, coinB.type],
                        //   arguments: [
                        //     txb.object(getConf().VERSION),
                        //     txb.object(poolInfo[poolName].poolId),
                        //     txb.object(poolInfo[poolName].investorId),
                        //     txb.object(getConf().ALPHA_DISTRIBUTOR),
                        //     txb.object(getConf().CETUS_GLOBAL_CONFIG_ID),
                        //     txb.object(getConf().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        //     txb.object(cetusPoolMap[`${coinBName}-SUI`]),
                        //     txb.object(cetusPoolMap["CETUS-SUI"]),
                        //     txb.object(cetusPoolMap[poolName]),
                        //     txb.object(getConf().CLOCK_PACKAGE_ID),
                        //   ],
                        // });
                    }
                }
                else if (index_js_1.poolInfo[poolName].parentProtocolName == "NAVI") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_navi_pool::get_user_rewards_all`,
                            typeArguments: [
                                index_js_1.coinsList[index_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (index_js_1.poolInfo[poolName].parentProtocolName == "ALPHALEND") {
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_alphalend_single_loop_pool::get_user_rewards_all`,
                            typeArguments: [
                                index_js_1.coinsList[index_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_ALPHALEND_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
                else if (index_js_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
                    const coinAName = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
                    const coinA = index_js_1.coinsList[coinAName];
                    const coinBName = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
                    const coinB = index_js_1.coinsList[coinBName];
                    receipts.forEach((receipt) => {
                        alpha_receipt = txb.moveCall({
                            target: `${index_js_1.poolInfo[poolName].packageId}::alphafi_lyf_pool::get_user_rewards_all`,
                            typeArguments: [coinA.type, coinB.type],
                            arguments: [
                                txb.object((0, index_js_1.getConf)().ALPHA_LYF_VERSION),
                                txb.object((0, index_js_1.getConf)().VERSION),
                                txb.object(receipt.objectId),
                                alpha_receipt,
                                txb.object(index_js_1.poolInfo[poolName].poolId),
                                txb.object(index_js_1.poolInfo["ALPHA"].poolId),
                                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                            ],
                        });
                    });
                }
            }
        }
    }
    txb.moveCall({
        target: `${(0, index_js_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphapool::transfer_receipt_option`,
        arguments: [txb.object((0, index_js_1.getConf)().VERSION), alpha_receipt],
    });
    return txb;
}
async function collectAndSwapRewardsSingleLoop(poolName, tx) {
    const txb = tx ? tx : new transactions_1.Transaction();
    const C = (0, index_js_1.getConf)();
    const poolData = index_js_1.poolInfo[poolName];
    if (poolName === "ALPHALEND-SINGLE-LOOP-TBTC") {
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["ALPHA"].type,
                index_js_1.coinsList["STSUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`ALPHA-STSUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(false),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["STSUI"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`STSUI-SUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["BLUE"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`BLUE-SUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["DEEP"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`DEEP-SUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["SUI"].type,
                index_js_1.coinsList["USDC"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`SUI-USDC-175`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["TBTC"].type,
                index_js_1.coinsList["USDC"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`TBTC-USDC`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(false),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
    }
    else if (poolName === "ALPHALEND-SINGLE-LOOP-SUIBTC") {
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["SUIBTC"].type,
                index_js_1.coinsList["ALPHA"].type,
                index_js_1.coinsList["STSUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`ALPHA-STSUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(false),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["SUIBTC"].type,
                index_js_1.coinsList["BLUE"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`BLUE-SUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["SUIBTC"].type,
                index_js_1.coinsList["DEEP"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`DEEP-SUI-175`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["SUIBTC"].type,
                index_js_1.coinsList["SUI"].type,
                index_js_1.coinsList["SUIBTC"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`SUI-SUIBTC`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
    }
    else if (poolName === "ALPHALEND-SINGLE-LOOP-XAUM") {
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["XAUM"].type,
                index_js_1.coinsList["ALPHA"].type,
                index_js_1.coinsList["USDC"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`ALPHA-USDC`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["XAUM"].type,
                index_js_1.coinsList["DEEP"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`DEEP-SUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["XAUM"].type,
                index_js_1.coinsList["BLUE"].type,
                index_js_1.coinsList["SUI"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`BLUE-SUI`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_bluefin`,
            typeArguments: [
                index_js_1.coinsList["XAUM"].type,
                index_js_1.coinsList["SUI"].type,
                index_js_1.coinsList["USDC"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(index_js_1.bluefinPoolMap[`SUI-USDC-175`]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.pure.bool(true),
                txb.pure.bool(true),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${poolData.packageId}::alphafi_alphalend_single_loop_pool::collect_reward_and_swap_mmt`,
            typeArguments: [
                index_js_1.coinsList["XAUM"].type,
                index_js_1.coinsList["XAUM"].type,
                index_js_1.coinsList["USDC"].type,
            ],
            arguments: [
                txb.object(C.ALPHA_ALPHALEND_VERSION),
                txb.object(poolData.investorId),
                txb.object(C.LENDING_PROTOCOL_ID),
                txb.object(C.MMT_XAUM_USDC_POOL),
                txb.object(C.MMT_VERSION),
                txb.pure.bool(false),
                txb.pure.bool(true),
                txb.pure.u64(10),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
    }
    return txb;
}
async function collectAndSwapRewardsLyf(poolname, tx) {
    const txb = tx ? tx : new transactions_1.Transaction();
    const pool = index_js_1.poolInfo[poolname];
    const coin1 = index_js_1.doubleAssetPoolCoinMap[poolname].coin1;
    const coin2 = index_js_1.doubleAssetPoolCoinMap[poolname].coin2;
    if (pool.strategyType === "LEVERAGE-YIELD-FARMING") {
        if (poolname === "BLUEFIN-LYF-STSUI-SUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_lyf_pool::collect_reward_and_swap_bluefin`,
                typeArguments: [
                    index_js_1.coinsList[coin1].type,
                    index_js_1.coinsList[coin2].type,
                    index_js_1.coinsList["BLUE"].type,
                    index_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_LYF_VERSION),
                    txb.object(pool.poolId),
                    txb.object((0, index_js_1.getConf)().LENDING_PROTOCOL_ID),
                    txb.object(pool.parentPoolId),
                    txb.object(index_js_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.bool(true),
                    txb.pure.bool(true),
                    txb.pure.bool(true),
                    txb.object((0, index_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_lyf_pool::collect_reward_and_swap_bluefin`,
                typeArguments: [
                    index_js_1.coinsList[coin1].type,
                    index_js_1.coinsList[coin2].type,
                    index_js_1.coinsList["BLUE"].type,
                    index_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_LYF_VERSION),
                    txb.object(pool.poolId),
                    txb.object((0, index_js_1.getConf)().LENDING_PROTOCOL_ID),
                    txb.object(pool.parentPoolId),
                    txb.object(index_js_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.bool(true),
                    txb.pure.bool(true),
                    txb.pure.bool(false),
                    txb.object((0, index_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_lyf_pool::collect_reward_and_swap_bluefin`,
                typeArguments: [
                    index_js_1.coinsList[coin1].type,
                    index_js_1.coinsList[coin2].type,
                    index_js_1.coinsList["ALPHA"].type,
                    index_js_1.coinsList["STSUI"].type,
                ],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_LYF_VERSION),
                    txb.object(pool.poolId),
                    txb.object((0, index_js_1.getConf)().LENDING_PROTOCOL_ID),
                    txb.object(pool.parentPoolId),
                    txb.object(index_js_1.bluefinPoolMap["ALPHA-STSUI"]),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.bool(true),
                    txb.pure.bool(true),
                    txb.pure.bool(false),
                    txb.object((0, index_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    return txb;
}
//# sourceMappingURL=collect_rewards.js.map